import {
  IBarcodeStyle
} from "../../../../documaker/domain/format/objects";
import { ITextPresentableObject, instanceOfITextPresentableObject } from "./ITextPresentableObject";

export interface IBarcodeObject extends ITextPresentableObject {
  barcodeStyle: IBarcodeStyle;
  items: IBarcodeItem[];
}

export interface IBarcodeItem {
  isHisItem: boolean;
  value: string;      // HIS項目の場合key、HIS項目以外の場合固定文字列を格納.
}

export function instanceOfIBarcodeObject(instance: any): instance is IBarcodeObject {
  return instance
      && (instance.barcodeStyle !== undefined)
      && (instance.items !== undefined)
      && instanceOfITextPresentableObject<IBarcodeObject>(instance, "barcode");
}
